export default {
  apiKey: "AIzaSyAfARmh4Ze1H--oWS18t1Sv7bOjh_oYBXY",
  authDomain: "gitapp-b6d0d.firebaseapp.com",
  databaseURL: "https://gitapp-b6d0d.firebaseio.com",
  projectId: "gitapp-b6d0d",
  storageBucket: "gitapp-b6d0d.appspot.com",
  messagingSenderId: "727642808823",
  appId: "1:727642808823:web:867503a6d76b37f21f0ef2",
  measurementId: "G-HZF91FZTMF",
};
